import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
  baseURL: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
      }

      const token = getCookie('authToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      headers.set('Accept', 'application/json');
      headers.set('Content-Type', 'application/json');

      return headers;
    },
  }),
  endpoints: () => ({}),
  tagTypes: ['Auth', 'Dashboard', 'Orders', 'Positions', 'Holdings', 'Funds', 'Advisors', 'SubscriptionStatus'],
});

export default baseApi;
